import Flights from 'assets/images/products/flights.svg';
import Hotels from 'assets/images/products/hotels.svg';
import Packages from 'assets/images/products/packages.svg';
import Visa from 'assets/images/products/visa.svg';

export const title = 'Comments';

export const REQUEST_TYPE_BOOKING_CODE = 'booking_code';
export const REQUEST_TYPE_MEMBER_CODE = 'member_code';
export const REQUEST_TYPE_REQUIREMENT_CODE = 'requirement_code';

export const STATUS_REQUESTS = [
    {
        id: 'all',
        title: 'All'
    },
    {
        id: 'open',
        title: 'Open'
    },
    {
        id: 'close',
        title: 'Close'
    }
];

export const TICKET_TYPE = [
    {
        id: 'all_tickets',
        label: 'All Tickets'
    },
    {
        id: 'my_raised_tickets',
        label: 'My Raised Tickets'
    },
    {
        id: 'my_tickets',
        label: 'My Tickets'
    },
    {
        id: 'others',
        label: 'Others'
    }
];

export const REFERENCE_ID_LIST = [
    {
        id: 'booking_code',
        label: 'Booking Code'
    },
    {
        id: 'member_code',
        label: 'Member Code'
    },
    {
        id: 'requirement_code',
        label: 'Requirement Code'
    },
    {
        id: 'member_id',
        label: 'Member Id'
    }
];

export const CONVERSATION_DROPDOWN = [
    {
        id: 'travel_agents_and_travellers',
        name: 'Travel Agents and Travellers.',
        label: 'Travel Agents and Travellers.',
        value: 4
    },
    {
        id: 'travel_agents',
        name: 'Travel Agents Only.',
        label: 'Travel Agents Only.',
        value: 1
    }
];

export const headCells = [
    { id: 'ticket_code', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Code', showSort: false },
    { id: 'ticket_status', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Status', showSort: false },
    { id: 'reference_id', numeric: true, disablePadding: false, align: 'left', label: 'Reference Id', showSort: false },
    { id: 'issue_category', numeric: true, disablePadding: false, align: 'left', label: 'Issue Category', showSort: false },
    { id: 'request_type', numeric: true, disablePadding: false, align: 'left', label: 'Request Type', showSort: false },
    { id: 'tags', numeric: true, disablePadding: false, align: 'left', label: 'Tags', showSort: false },
    { id: 'team', numeric: true, disablePadding: false, align: 'left', label: 'Team', showSort: false },
    { id: 'assigned_to', numeric: true, disablePadding: false, align: 'left', label: 'Assignee', showSort: false },
    { id: 'priority', numeric: true, disablePadding: false, align: 'left', label: 'Priority', showSort: false },
    { id: 'member_buying_potential', numeric: false, disablePadding: false, align: 'left', label: 'Buying Potential', showSort: false },
    { id: 'created_by', numeric: true, disablePadding: false, align: 'left', label: 'Created By', showSort: false },
    { id: 'next_action_at', numeric: false, disablePadding: false, align: 'left', label: 'Next Action At', showSort: true },
    { id: 'comment_by', numeric: false, disablePadding: false, align: 'left', label: 'Comment By', showSort: false },
    { id: 'updated_at', numeric: false, disablePadding: false, align: 'left', label: 'Updated At', showSort: true },
    { id: 'created_at', numeric: false, disablePadding: false, align: 'left', label: 'Created At', showSort: true }
];

export const travclanHelpHeadCells = [
    { id: 'ticket_code', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Code', showSort: false },
    { id: 'ticket_status', numeric: false, disablePadding: false, align: 'left', label: 'Ticket Status', showSort: false },
    { id: 'reference_id', numeric: true, disablePadding: false, align: 'left', label: 'Reference Id', showSort: false },
    { id: 'issue_category', numeric: true, disablePadding: false, align: 'left', label: 'Issue Category', showSort: false },
    { id: 'request_type', numeric: true, disablePadding: false, align: 'left', label: 'Request Type', showSort: false },
    { id: 'tags', numeric: true, disablePadding: false, align: 'left', label: 'Tags', showSort: false },
    { id: 'team', numeric: true, disablePadding: false, align: 'left', label: 'Team', showSort: false },
    { id: 'assigned_to', numeric: true, disablePadding: false, align: 'left', label: 'Assignee', showSort: false },
    { id: 'priority', numeric: false, disablePadding: false, align: 'left', label: 'Priority' },
    { id: 'member_buying_potential', numeric: false, disablePadding: false, align: 'left', label: 'Buying Potential', showSort: false },
    { id: 'next_action_at', numeric: false, disablePadding: false, align: 'left', label: 'Next Action At', showSort: true },
    { id: 'comment_by', numeric: false, disablePadding: false, align: 'left', label: 'Comment By', showSort: false },
    { id: 'updated_at', numeric: false, disablePadding: false, align: 'left', label: 'Updated At', showSort: true },
    { id: 'created_at', numeric: false, disablePadding: false, align: 'left', label: 'Created At', showSort: true }
];

export const ticketStatusHistoryHeadCells = [
    { id: 'category', numeric: true, disablePadding: false, align: 'left', label: 'Category' },
    { id: 'request_type', numeric: false, disablePadding: false, align: 'left', label: 'Request Type' },
    { id: 'tags', numeric: true, disablePadding: false, align: 'left', label: 'Tags' },
    { id: 'team', numeric: false, disablePadding: false, align: 'left', label: 'Team' },
    { id: 'assignee', numeric: false, disablePadding: false, align: 'left', label: 'Assignee' },
    { id: 'status', numeric: false, disablePadding: false, align: 'left', label: 'Status' },
    { id: 'priority', numeric: false, disablePadding: false, align: 'left', label: 'Priority' },
    { id: 'updated_at', numeric: false, disablePadding: false, align: 'left', label: 'Updated at' },
    { id: 'updated_by', numeric: false, disablePadding: false, align: 'left', label: 'Updated by' }
];

export const DURATION_FILTER_DROPDOWN_DATA = [
    {
        label: 'Today',
        id: 'today'
    },
    {
        label: 'Yesterday',
        id: 'yesterday'
    },
    {
        label: 'Last 3 days',
        id: 'last_3_days'
    },
    {
        label: 'Last 7 days',
        id: 'last_7_days'
    },
    {
        label: 'Last 15 days',
        id: 'last_15_days'
    },
    {
        label: 'Last 30 days',
        id: 'last_30_days'
    }
];

export const PRIORITY_FILTER_DROPDOWN_DATA = [
    {
        label: 'Low',
        id: '1'
    },
    {
        label: 'Medium',
        id: '2'
    },
    {
        label: 'High',
        id: '3'
    },
    {
        label: 'Critical',
        id: '4'
    }
];

export const DURATION_FILTER_KEYS = {
    today: '0',
    yesterday: '1',
    last_3_days: '2',
    last_7_days: '6',
    last_15_days: '14',
    last_30_days: '29'
};

export const CATEGORY_ICON_MAP = {
    3: Flights,
    4: Hotels,
    5: Packages,
    6: Visa
};

export const TICKET_TYPE_CONSTANTS = {
    my_tickets: 'assigned_to',
    my_raised_tickets: 'created_by',
    others: 'other_requests'
};
export const DEFAULT_ORDER = 'desc';
export const DEFAULT_ORDER_BY = 'updated_at';
export const REQUEST_TYPE_KEY = 'request_type';
export const REQUEST_TYPE_PENDING = 'pending_requests';
export const REQUEST_TYPE_FAILED = 'failed_requests';
export const FILTER_TYPE_SEARCH = 'search';
export const SERVICE_REQUEST_STATUS = 'service_request_status';
export const CATEGORY_FLIGHTS = 'Flights';
export const CATEGORY_ACCOMODATION = 'Accommodation (Hotel)';
export const BOOKING_TYPE = 'bookings';
export const PAX_TYPE = 'pax';
export const DEFAULT_ERROR_MESSAGE = 'Something Went Wrong';
export const VIEW_TYPE_INTERNAL_COMMENTING = 'internal_commenting';

export const INTERNAL_COMMENTING_VIEW_TYPES = {
    TRAVCLAN_HELP: {
        id: 1,
        name: 'Internal Queries'
    },
    INTERNAL_COMMENTING: {
        id: 2,
        name: 'Internal Queries'
    }
};
